module.exports = __webpack_public_path__ + "img/20f4.d825eb92.jpg";